import { DispatchThunk } from '../../types/common';
import { LaunchType } from '../../types/launch';
import { LaunchState } from '../defaults/launch';
import { getIsUserLoggedIn } from '../selectors/config';
import { getLaunchPageType } from '../selectors/launch';

export const UPDATE_LAUNCH = 'APP_UPDATE_LAUNCH';

export function updateLaunch(payload: Partial<LaunchState>) {
  return {
    type: UPDATE_LAUNCH,
    payload,
  };
}

export function setAutoSave(payload: { launchChannelId?: string; launchShowId?: string }) {
  return updateLaunch(payload);
}

export function setAutoSaveShowId(launchShowId: string): DispatchThunk {
  return (dispatch, getState) => {
    const state = getState();
    const isUserLoggedIn = getIsUserLoggedIn(state);
    const isShowLaunchPage = getLaunchPageType(state) === LaunchType.SHOW;
    if (!isUserLoggedIn && isShowLaunchPage) {
      dispatch(setAutoSave({ launchShowId }));
    }
  };
}
